var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-capture-view"},[_c('base-button',{staticClass:"expand",attrs:{"icon":"","size":"sm"},on:{"click":_vm.toogleScanner}},[_c('i',{staticClass:"far fa-expand"})]),_c('div',{style:({ display: _vm.scanOpened ? 'block' : 'none' }),attrs:{"id":"data-capture-view"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }